module.exports = "./app-dist/fonts/spice-grey.66f0dc068973fe89d5847034eed9ef95.svg";